import React, { Fragment } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Select from "react-select";

import { productActions } from '../../../_store';


const InventoryTab = () => {
    const dispatch = useDispatch();
 const CurrentUser = useSelector(x => x.auth.user);
   // #region Reducers ------------------  Reducers --------------------------------
  const vendorDrpList = useSelector(state => state.master.vendorDrpList);
  const genInventoryTabData = useSelector(state => state.product.productTabList);
  // #endregion Reducers ------------------  Reducers End --------------------------------

  const submitted = genInventoryTabData?.setSubmitted;

    let newFormData = { ...genInventoryTabData };

    const AllowbackordersList = [
        { value: 1, label: "Do not allow" },
        //  { value: 2, label: "Allow, but notify Customer" },
        { value: 3, label: "Allow" },
    ]
    
    const styles = {
        control: (base) => ({ ...base, border: '1px solid red' }),
      };

    // handle Change function
    const handleChange = (event) => {
        event.preventDefault();
        const regexNoSymbolSpace = /^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/;
        const regexNoSymbol = /^[A-Za-z0-9\b]+$/;
        const regexNumber = /^[0-9\b]+$/;
        const fieldName = event.target.getAttribute('name');
        const fieldValue = event.target.value.trim();  // Trim value upfront
    
        // Initialize or copy new form data
        let newFormData = { ...genInventoryTabData };
    
        switch (fieldName) {
            case "StockQuantity":
            case "LowStockThreshold":
            case "QuotaTrigger1":
            case "QuotaTrigger2":
            case "HighStockThreshold":
                if (fieldValue === "" || regexNumber.test(fieldValue)) {
                    newFormData[fieldName] = fieldValue;
                }
                break;
    
            case "Manufacturer":
                if (fieldValue === "" || regexNoSymbolSpace.test(fieldValue)) {
                    newFormData[fieldName] =  event.target.value;
                }
                break;
            case "SKU":
                if (fieldValue === "" || regexNoSymbol.test(fieldValue)) {
                    newFormData[fieldName] = fieldValue;
                }
                break;
    
            default:
                newFormData[fieldName] = fieldValue;
                break;
        }
    
        dispatch(productActions.tempSetProductTabData(newFormData));
    };
    

    // handle Dropdown Change function
    const handleDrpChange = (event, title) => {
        // Initialize or copy new form data
        let newFormData = { ...genInventoryTabData };
    
        // Update form data based on dropdown selection
        newFormData[title] = event.value ? parseInt(event.value) : null;
    
        switch (title) {
            case "VendorID":
                newFormData.VendorOption = {
                    value: parseInt(event.value),
                    label: event.label,
                };
                break;
    
            case "StockStatusID":
                newFormData.StockstatusOption = {
                    value: parseInt(event.value),
                    label: event.label,
                };
                break;
    
            case "AllowBackOrder":
                newFormData.AllowbackordersOption = {
                    value: parseInt(event.value),
                    label: event.label,
                };
                break;
    
            default:
                // Handle other cases or log an error
                console.warn(`Unhandled dropdown title: ${title}`);
                break;
        }
    
        // Dispatch the updated form data
        dispatch(productActions.tempSetProductTabData(newFormData));
    };
    

    
    const tabChange = () => {
        dispatch(productActions.tempActiveProductTab("Attributes"));

    }
    const prevChange = () => {
        dispatch(productActions.tempActiveProductTab("General"));

    }

    return (
        <Fragment>
            <div className="tab-content">

                <div className="pt-3">
                    <div className="Inventory-form">
                        <div className="row">
                            <div className="form-group mb-3 col-md-4">

                                <label className="text-black font-w500" > Stock Quantity </label>
                                <input type="text" placeholder="Stock Quantity"
                                    id="StockQuantity"
                                    name="StockQuantity"
                                    //className={`form-control ${genInventoryTabData.ProductID > 0 && 'readonly_css '} ${(submitted && (((!genInventoryTabData.StockQuantity || parseInt(genInventoryTabData.StockQuantity) === 0)) && (!genInventoryTabData.ProductID || genInventoryTabData.ProductID === 0))) && 'border-danger'}`}
                                    className={`form-control readonly_css `}
                                    value={genInventoryTabData.StockQuantity}
                                    onChange={e => handleChange(e)}
                                    readOnly={true}
                                   // readOnly={genInventoryTabData.ProductID > 0 ? true : false}
                                    maxLength={10}

                                />
                            </div>
                            <div className="form-group mb-3 col-md-4">
  <label className="text-black font-w500">
    Allow backorders? <span className="text-danger">*</span>
  </label>
  <Select
    classNamePrefix="custom_select_css"
    name="AllowBackOrder"
    value={genInventoryTabData.AllowbackordersOption}
    onChange={(event) => handleDrpChange(event, "AllowBackOrder")}
    options={AllowbackordersList}
    styles={
      submitted && genInventoryTabData.AllowBackOrder === 0 ? styles : ""
    }
    isDisabled={CurrentUser.UserTypeID === 8}   // ✅ makes dropdown readonly
  />
</div>

                      <div className="form-group mb-3 col-md-4">
  <label className="text-black font-w500">
    Low Stock Threshold <span className="text-danger">*</span>
  </label>
  <input
    type="text"
    name="LowStockThreshold"
    placeholder="Low Stock Threshold"
    className={`form-control ${
      submitted &&
      (!genInventoryTabData.LowStockThreshold ||
        parseInt(genInventoryTabData.LowStockThreshold) === 0) &&
      "border-danger"
    }`}
    value={genInventoryTabData.LowStockThreshold}
    onChange={(e) => handleChange(e)}
    maxLength={10}
    readOnly={CurrentUser.UserTypeID === 8}
    style={{
      backgroundColor: CurrentUser.UserTypeID === 8 ? "#f5f5f5" : "white",
      cursor: CurrentUser.UserTypeID === 8 ? "not-allowed" : "text",
    }}
  />
</div>

<div className="form-group mb-3 col-md-4">
  <label className="text-black font-w500">
    High Stock Threshold <span className="text-danger">*</span>
  </label>
  <input
    type="text"
    name="HighStockThreshold"
    placeholder="High Stock Threshold"
    className={`form-control ${
      submitted &&
      (!genInventoryTabData.HighStockThreshold ||
        parseInt(genInventoryTabData.HighStockThreshold) === 0) &&
      "border-danger"
    }`}
    value={genInventoryTabData.HighStockThreshold}
    onChange={(e) => handleChange(e)}
    maxLength={10}
    readOnly={CurrentUser.UserTypeID === 8}
    style={{
      backgroundColor: CurrentUser.UserTypeID === 8 ? "#f5f5f5" : "white",
      cursor: CurrentUser.UserTypeID === 8 ? "not-allowed" : "text",
    }}
  />
</div>

<div className="form-group mb-3 col-md-4">
  <label className="text-black font-w500">
    Quota Trigger 2 <span className="text-danger">*</span>
  </label>
  <input
    type="text"
    name="QuotaTrigger2"
    placeholder="Quota Trigger 2"
    className={`form-control ${
      submitted &&
      ((!genInventoryTabData.QuotaTrigger2 ||
        parseInt(genInventoryTabData.QuotaTrigger2) >
          parseInt(genInventoryTabData.QuotaTrigger1) ||
        genInventoryTabData.QuotaTrigger2 ===
          genInventoryTabData.QuotaTrigger1) &&
        "border-danger")
    }`}
    value={genInventoryTabData.QuotaTrigger2}
    onChange={(e) => handleChange(e)}
    maxLength={10}
    readOnly={CurrentUser.UserTypeID === 8}
    style={{
      backgroundColor: CurrentUser.UserTypeID === 8 ? "#f5f5f5" : "white",
      cursor: CurrentUser.UserTypeID === 8 ? "not-allowed" : "text",
    }}
  />
</div>

<div className="form-group mb-3 col-md-4">
  <label className="text-black font-w500">
    Quota Trigger 1 <span className="text-danger">*</span>
  </label>
  <input
    type="text"
    name="QuotaTrigger1"
    placeholder="Quota Trigger 1"
    className={`form-control ${
      submitted &&
      ((!genInventoryTabData.QuotaTrigger1 ||
        parseInt(genInventoryTabData.QuotaTrigger2) >
          parseInt(genInventoryTabData.QuotaTrigger1) ||
        genInventoryTabData.QuotaTrigger2 ==
          genInventoryTabData.QuotaTrigger1) &&
        "border-danger")
    }`}
    value={genInventoryTabData.QuotaTrigger1}
    onChange={(e) => handleChange(e)}
    maxLength={10}
    readOnly={CurrentUser.UserTypeID === 8}
    style={{
      backgroundColor: CurrentUser.UserTypeID === 8 ? "#f5f5f5" : "white",
      cursor: CurrentUser.UserTypeID === 8 ? "not-allowed" : "text",
    }}
  />
</div>


                        </div>
                        
                        <div className="row">
                            <div className="form-group mb-3 col-md-4">
                                <label className="text-black font-w500" > SKU <span className="text-danger">*</span> </label>
                                <>
                                {
                                    ((genInventoryTabData.ProductID > 0 && CurrentUser.UserTypeID !== 1) ?
                                    <input type="text"
                                    name="SKU"
                                    placeholder="SKU"
                                    className={`form-control ${(genInventoryTabData.ProductID > 0 && CurrentUser.UserTypeID !== 1) ?  'readonly_css ':''} ${(submitted && !genInventoryTabData.SKU) && 'border-danger'}`}
                                    value={genInventoryTabData.SKU}
                                    readOnly={true}
                                    maxLength={15} />
                                    :
                                    <input type="text"
                                    name="SKU"
                                    placeholder="SKU"
                                    className={`form-control ${(genInventoryTabData.ProductID > 0 && CurrentUser.UserTypeID !== 1) ?  'readonly_css ':''} ${(submitted && !genInventoryTabData.SKU) && 'border-danger'}`}
                                    //className={`form-control ${(submitted && !genInventoryTabData.SKU) && 'border-danger'}`}
                                    value={genInventoryTabData.SKU}
                                    onChange={e => handleChange(e)}
                                    readOnly={genInventoryTabData.ProductID > 0 && CurrentUser.UserTypeID !== 1? true : false}
                                    maxLength={15} />

                                    )

                                }
                                </>
                                
                                
                            </div>

                            <div className="form-group mb-3 col-md-4">
                                <label className="text-black font-w500">Vendor <span className="text-danger">*</span></label>
                                <Select
                                    classNamePrefix={"custom_select_css"}
                                    name="VendorID"
                                    value={genInventoryTabData.VendorOption}
                                    options={vendorDrpList}
                                    onChange={(event) => handleDrpChange(event, "VendorID")}
                                    isDisabled={CurrentUser.UserTypeID === 8}
                                    styles={submitted && genInventoryTabData.VendorID === 0 ? styles : ''}

                                />
                            </div>
                            <div className="form-group mb-3 col-md-4">
                                <label className="text-black font-w500" > Manufacturer  <span className="text-danger">*</span></label>
                                <input type="text"
                                    name="Manufacturer"
                                    placeholder="Manufacturer"
                                    className={`form-control ${(submitted && !genInventoryTabData.Manufacturer) && 'border-danger'}`}
                                    value={genInventoryTabData.Manufacturer}
                                    readOnly={CurrentUser.UserTypeID === 8}
    style={{
      backgroundColor: CurrentUser.UserTypeID === 8 ? "#f5f5f5" : "white",
      cursor: CurrentUser.UserTypeID === 8 ? "not-allowed" : "text",
    }}
                                    onChange={e => handleChange(e)} maxLength={50} />
                                    
                            </div>
                        </div>



                        <button className="btn btn-primary" style={{ float: "right" }} onClick={tabChange} type="submit">Next</button>

                        <button className="btn btn-danger" style={{ float: "right", marginRight: "17px" }} onClick={prevChange} type="submit">Previous </button>

                    </div>
                </div>
            </div>

        </Fragment >
    );
};
export default React.memo(InventoryTab);